














 
























































































































































































































































































































































































































































































































































const node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "meetingId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "meetingId",
    "variableName": "meetingId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fieldName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "groupTitle",
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "AutogroupReflectionGroup",
  "kind": "LinkedField",
  "name": "resetReflectionGroups",
  "plural": true,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "smartTitle",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plaintextContent",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "AutogroupSuccess",
  "kind": "LinkedField",
  "name": "AutogroupSuccess",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetrospectiveMeeting",
      "kind": "LinkedField",
      "name": "meeting",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RetroReflectionGroup",
          "kind": "LinkedField",
          "name": "reflectionGroups",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "RetroReflection",
              "kind": "LinkedField",
              "name": "reflections",
              "plural": true,
              "selections": [
                (v3/*: any*/),
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promptId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reflectionGroupId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "ResetReflectionGroupsSuccess",
  "kind": "LinkedField",
  "name": "ResetReflectionGroupsSuccess",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetrospectiveMeeting",
      "kind": "LinkedField",
      "name": "meeting",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RetroReflectionGroup",
          "kind": "LinkedField",
          "name": "reflectionGroups",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            (v6/*: any*/),
            (v10/*: any*/),
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "RetroReflection",
              "kind": "LinkedField",
              "name": "reflections",
              "plural": true,
              "selections": [
                (v3/*: any*/),
                (v8/*: any*/),
                (v11/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "AutogroupReflectionGroup",
  "kind": "LinkedField",
  "name": "autogroupReflectionGroups",
  "plural": true,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingPrompt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "UpdateMeetingPromptSuccess",
  "kind": "LinkedField",
  "name": "UpdateMeetingPromptSuccess",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamPromptMeeting",
      "kind": "LinkedField",
      "name": "meeting",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v14/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finalScore",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSpectating",
  "storageKey": null
},
v18 = [
  (v17/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isHover",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stageId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVoting",
  "storageKey": null
},
v25 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "PokerVotingRow_scores"
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "EstimateUserScore",
  "kind": "LinkedField",
  "name": "scores",
  "plural": true,
  "selections": [
    (v25/*: any*/),
    (v19/*: any*/),
    (v26/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewerReactji",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v30 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ThreadedItem_threadable"
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discussionId",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "threadSortOrder",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "threadParentId",
  "storageKey": null
},
v34 = [
  (v3/*: any*/),
  (v6/*: any*/)
],
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "PollOption",
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": (v34/*: any*/),
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v37 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ReflectionCard_reflection"
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewerDragging",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDropping",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEditing",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dragUserId",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSpotlight",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dragUserName",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetId",
  "storageKey": null
},
v45 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "RemoteReflection_reflection"
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewerCreator",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerVoteCount",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleIsUserDefined",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExpanded",
  "storageKey": null
},
v50 = {
  "kind": "ClientExtension",
  "selections": [
    (v49/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subColumnIdx",
      "storageKey": null
    }
  ]
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "voteCount",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNavigableByFacilitator",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "unlockedStages",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v52/*: any*/)
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "DeleteCommentSuccess",
  "kind": "LinkedField",
  "name": "DeleteCommentSuccess",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "comment",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v54/*: any*/),
        (v55/*: any*/),
        (v33/*: any*/),
        (v31/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "RetroDiscussStage",
  "kind": "LinkedField",
  "name": "stage",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v36/*: any*/)
  ],
  "storageKey": null
},
v58 = [
  (v3/*: any*/)
],
v59 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "meeting",
  "plural": false,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredName",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "commentors",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v60/*: any*/),
    (v61/*: any*/)
  ],
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "EditReflectionPayload",
  "kind": "LinkedField",
  "name": "EditReflectionPayload",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "editorId",
      "storageKey": null
    },
    (v40/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamId",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "RetrospectiveMeeting",
  "kind": "LinkedField",
  "name": "meeting",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextAutoGroupThreshold",
      "storageKey": null
    },
    (v64/*: any*/)
  ],
  "storageKey": null
},
v66 = [
  (v37/*: any*/),
  (v45/*: any*/),
  (v3/*: any*/),
  (v10/*: any*/),
  (v46/*: any*/),
  (v11/*: any*/),
  {
    "kind": "ClientExtension",
    "selections": [
      (v40/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "RemoteReflectionDrag",
        "kind": "LinkedField",
        "name": "remoteDrag",
        "plural": false,
        "selections": [
          (v41/*: any*/),
          (v43/*: any*/),
          (v42/*: any*/),
          (v44/*: any*/)
        ],
        "storageKey": null
      }
    ]
  }
],
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "RetroReflectionGroup",
  "kind": "LinkedField",
  "name": "oldReflectionGroup",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dropTargetType",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dropTargetId",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "RemoteReflectionDrag",
  "kind": "LinkedField",
  "name": "remoteDrag",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v41/*: any*/),
    (v43/*: any*/),
    (v42/*: any*/)
  ],
  "storageKey": null
},
v71 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "WholeMeetingSummary_meeting"
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskCount",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewerReady",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readyCount",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facilitatorUserId",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "RetroReflection",
  "kind": "LinkedField",
  "name": "reflection",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplete",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNavigable",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesRemaining",
  "storageKey": null
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetrospectiveMeetingMember",
      "kind": "LinkedField",
      "name": "viewerMeetingMember",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v80/*: any*/)
      ],
      "storageKey": null
    },
    (v80/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RetroReflectionGroup",
      "kind": "LinkedField",
      "name": "reflectionGroups",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v21/*: any*/),
        (v47/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "RetrospectiveMeeting",
  "abstractKey": null
},
v82 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TeamHealthLocalStage"
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "focusedPromptId",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAsync",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledEndTime",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeRemaining",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "labels",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerVote",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votes",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "concreteType": "StartDraggingReflectionPayload",
  "kind": "LinkedField",
  "name": "StartDraggingReflectionPayload",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reflectionId",
      "storageKey": null
    },
    (v64/*: any*/),
    (v70/*: any*/)
  ],
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": (v1/*: any*/),
  "kind": "ScalarField",
  "name": "isHighlighted",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "concreteType": "SetTaskHighlightSuccess",
  "kind": "LinkedField",
  "name": "SetTaskHighlightSuccess",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        (v61/*: any*/),
        (v3/*: any*/),
        (v91/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "concreteType": "UpdateCommentContentSuccess",
  "kind": "LinkedField",
  "name": "UpdateCommentContentSuccess",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "comment",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v55/*: any*/),
        (v93/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkInQuestion",
  "storageKey": null
},
v96 = {
  "kind": "InlineFragment",
  "selections": [
    (v95/*: any*/)
  ],
  "type": "CheckInPhase",
  "abstractKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientX",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientY",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientHeight",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientWidth",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetOffsetX",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetOffsetY",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "concreteType": "UpdateDragLocationPayload",
  "kind": "LinkedField",
  "name": "UpdateDragLocationPayload",
  "plural": false,
  "selections": [
    {
      "alias": "drag",
      "args": null,
      "concreteType": "RemoteReflectionDrag",
      "kind": "LinkedField",
      "name": "remoteDrag",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v97/*: any*/),
        (v98/*: any*/),
        (v99/*: any*/),
        (v100/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceId",
          "storageKey": null
        },
        (v44/*: any*/),
        (v101/*: any*/),
        (v102/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskId",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "concreteType": "ServiceField",
  "kind": "LinkedField",
  "name": "serviceField",
  "plural": false,
  "selections": [
    (v105/*: any*/),
    (v107/*: any*/)
  ],
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facilitatorStageId",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phaseType",
  "storageKey": null
},
v112 = [
  (v3/*: any*/),
  (v110/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "phases",
    "plural": true,
    "selections": [
      (v111/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "stages",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v78/*: any*/),
          (v79/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v113 = {
  "kind": "InlineDataFragmentSpread",
  "name": "fromStageIdToUrl_meeting",
  "selections": (v112/*: any*/),
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v114 = {
  "kind": "InlineDataFragmentSpread",
  "name": "updateLocalStage_meeting",
  "selections": (v112/*: any*/),
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v115 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingType",
  "storageKey": null
},
v116 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "stages",
    "plural": true,
    "selections": (v58/*: any*/),
    "storageKey": null
  }
],
v117 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "localStage",
      "plural": false,
      "selections": (v58/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "localPhase",
      "plural": false,
      "selections": (v116/*: any*/),
      "storageKey": null
    }
  ]
},
v118 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "queryString",
  "storageKey": null
},
v119 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectedProjectsIds",
  "storageKey": null
},
v120 = [
  (v118/*: any*/)
],
v121 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectKeyFilters",
  "storageKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalVotes",
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxVotesPerGroup",
  "storageKey": null
},
v124 = [
  (v80/*: any*/)
],
v125 = {
  "alias": null,
  "args": null,
  "concreteType": "StandardMutationError",
  "kind": "LinkedField",
  "name": "error",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "videoMeetingURL",
  "storageKey": null
},
v128 = [
  (v19/*: any*/),
  (v3/*: any*/)
],
v129 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNewMeeting"
},
v130 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenAt",
  "storageKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenAtURLs",
  "storageKey": null
},
v132 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "stages",
  "plural": true,
  "selections": [
    (v61/*: any*/),
    (v78/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v133 = [
  (v3/*: any*/),
  (v105/*: any*/)
],
v134 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v133/*: any*/),
  "storageKey": null
},
v135 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endedAt",
  "storageKey": null
},
v136 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNewMeetingStage"
},
v137 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v138 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupColor",
  "storageKey": null
},
v139 = {
  "alias": null,
  "args": null,
  "concreteType": "ReflectPrompt",
  "kind": "LinkedField",
  "name": "prompt",
  "plural": false,
  "selections": [
    (v137/*: any*/),
    (v138/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v140 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "users",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v60/*: any*/)
  ],
  "storageKey": null
},
v141 = {
  "alias": null,
  "args": null,
  "concreteType": "Reactji",
  "kind": "LinkedField",
  "name": "reactjis",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v29/*: any*/),
    (v28/*: any*/),
    (v140/*: any*/)
  ],
  "storageKey": null
},
v142 = [
  (v60/*: any*/),
  (v3/*: any*/)
],
v143 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v142/*: any*/),
  "storageKey": null
},
v144 = {
  "alias": null,
  "args": null,
  "concreteType": "RemoteReflectionDrag",
  "kind": "LinkedField",
  "name": "remoteDrag",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    (v43/*: any*/),
    (v42/*: any*/),
    (v99/*: any*/),
    (v100/*: any*/),
    (v97/*: any*/),
    (v98/*: any*/),
    (v44/*: any*/),
    (v101/*: any*/),
    (v102/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v145 = {
  "kind": "ClientExtension",
  "selections": [
    (v40/*: any*/),
    (v39/*: any*/),
    (v144/*: any*/),
    (v38/*: any*/)
  ]
},
v146 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v147 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "editorIds",
  "storageKey": null
},
v148 = {
  "alias": null,
  "args": null,
  "concreteType": "RetroReflection",
  "kind": "LinkedField",
  "name": "reflections",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v139/*: any*/),
    (v46/*: any*/),
    (v21/*: any*/),
    (v11/*: any*/),
    (v10/*: any*/),
    (v55/*: any*/),
    (v141/*: any*/),
    (v36/*: any*/),
    (v143/*: any*/),
    (v145/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v149 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tier",
  "storageKey": null
},
v150 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "facilitator",
  "plural": false,
  "selections": (v142/*: any*/),
  "storageKey": null
},
v151 = [
  (v109/*: any*/),
  (v60/*: any*/),
  (v3/*: any*/)
],
v152 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "teamMember",
  "plural": false,
  "selections": (v151/*: any*/),
  "storageKey": null
},
v153 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suggestedTimeLimit",
  "storageKey": null
},
v154 = {
  "alias": null,
  "args": null,
  "filters": null,
  "handle": "localTime",
  "key": "",
  "kind": "ScalarHandle",
  "name": "scheduledEndTime"
},
v155 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suggestedEndTime",
  "storageKey": null
},
v156 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamMemberId",
  "storageKey": null
},
v157 = {
  "kind": "InlineFragment",
  "selections": [
    (v156/*: any*/),
    (v152/*: any*/)
  ],
  "type": "NewMeetingTeamMemberStage",
  "abstractKey": "__isNewMeetingTeamMemberStage"
},
v158 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "teamMember",
      "plural": false,
      "selections": [
        (v19/*: any*/),
        (v60/*: any*/),
        (v109/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "CheckInStage",
  "abstractKey": null
},
v159 = [
  (v3/*: any*/),
  (v109/*: any*/),
  (v60/*: any*/)
],
v160 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "votedUsers",
  "plural": true,
  "selections": (v159/*: any*/),
  "storageKey": null
},
v161 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votedUserIds",
  "storageKey": null
},
v162 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRevealed",
  "storageKey": null
},
v163 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localScheduledEndTime",
  "storageKey": null
},
v164 = {
  "kind": "ClientExtension",
  "selections": [
    (v163/*: any*/)
  ]
},
v165 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNewMeetingPhase"
},
v166 = {
  "kind": "InlineFragment",
  "selections": [
    (v95/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingGreeting",
      "kind": "LinkedField",
      "name": "checkInGreeting",
      "plural": false,
      "selections": [
        (v55/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "language",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CheckInPhase",
  "abstractKey": null
},
v167 = [
  (v54/*: any*/),
  (v3/*: any*/)
],
v168 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TeamMemberIntegrationAuthWebhook",
    "kind": "LinkedField",
    "name": "auth",
    "plural": false,
    "selections": (v167/*: any*/),
    "storageKey": null
  }
],
v169 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMemberIntegrations",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MattermostIntegration",
      "kind": "LinkedField",
      "name": "mattermost",
      "plural": false,
      "selections": (v168/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MSTeamsIntegration",
      "kind": "LinkedField",
      "name": "msTeams",
      "plural": false,
      "selections": (v168/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SlackIntegration",
      "kind": "LinkedField",
      "name": "slack",
      "plural": false,
      "selections": [
        (v54/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultTeamChannelId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SlackNotification",
          "kind": "LinkedField",
          "name": "notifications",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "channelId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "event",
              "storageKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v170 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v76/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v171 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "viewerMeetingMember",
  "plural": false,
  "selections": [
    (v61/*: any*/)
  ],
  "storageKey": null
},
v172 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tierLimitExceededAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v173 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "teamMembers",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v174 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": [
    (v172/*: any*/),
    (v173/*: any*/)
  ],
  "storageKey": null
},
v175 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locked",
  "storageKey": null
},
v176 = {
  "alias": null,
  "args": null,
  "concreteType": "OrganizationUser",
  "kind": "LinkedField",
  "name": "viewerOrganizationUser",
  "plural": false,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v177 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v105/*: any*/),
    (v176/*: any*/)
  ],
  "storageKey": null
},
v178 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showSidebar",
  "storageKey": null
},
v179 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRightDrawerOpen",
  "storageKey": null
},
v180 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        (v179/*: any*/)
      ]
    }
  ],
  "type": "PokerMeeting",
  "abstractKey": null
},
v181 = {
  "kind": "InlineFragment",
  "selections": [
    (v156/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "teamMember",
      "plural": false,
      "selections": (v128/*: any*/),
      "storageKey": null
    }
  ],
  "type": "UpdatesStage",
  "abstractKey": null
},
v182 = {
  "kind": "InlineFragment",
  "selections": [
    (v31/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AgendaItem",
      "kind": "LinkedField",
      "name": "agendaItem",
      "plural": false,
      "selections": [
        (v55/*: any*/),
        (v152/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AgendaItemsStage",
  "abstractKey": null
},
v183 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinned",
  "storageKey": null
},
v184 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "teamMember",
  "plural": false,
  "selections": [
    (v109/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v185 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v186 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v187 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "descriptionHTML",
  "storageKey": null
},
v188 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v189 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueKey",
  "storageKey": null
},
v190 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectKey",
  "storageKey": null
},
v191 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyHTML",
  "storageKey": null
},
v192 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v193 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v194 = {
  "alias": null,
  "args": null,
  "concreteType": "_xGitHubRepository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v193/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v195 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v196 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "descriptionHtml",
  "storageKey": null
},
v197 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iid",
  "storageKey": null
},
v198 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webUrl",
  "storageKey": null
},
v199 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamProject",
  "storageKey": null
},
v200 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "integration",
  "plural": false,
  "selections": [
    (v61/*: any*/),
    (v3/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isTaskIntegration"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v187/*: any*/),
        (v188/*: any*/),
        (v189/*: any*/),
        (v190/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cloudName",
          "storageKey": null
        }
      ],
      "type": "JiraIssue",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v191/*: any*/),
        (v6/*: any*/),
        (v192/*: any*/),
        (v194/*: any*/)
      ],
      "type": "_xGitHubIssue",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v187/*: any*/),
        (v188/*: any*/),
        (v189/*: any*/),
        (v190/*: any*/),
        (v195/*: any*/)
      ],
      "type": "JiraServerIssue",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v196/*: any*/),
        (v6/*: any*/),
        (v197/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "webPath",
          "storageKey": null
        },
        (v198/*: any*/)
      ],
      "type": "_xGitLabIssue",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v187/*: any*/),
        (v6/*: any*/),
        (v199/*: any*/),
        (v107/*: any*/),
        (v195/*: any*/)
      ],
      "type": "AzureDevOpsWorkItem",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v201 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v202 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskEditorDetails",
  "kind": "LinkedField",
  "name": "editors",
  "plural": true,
  "selections": [
    (v19/*: any*/),
    (v60/*: any*/)
  ],
  "storageKey": null
},
v203 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v204 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueDate",
  "storageKey": null
},
v205 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v151/*: any*/),
  "storageKey": null
},
v206 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "error",
      "storageKey": null
    }
  ]
},
v207 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v208 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endCursor",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasNextPage",
    "storageKey": null
  }
],
v209 = [
  (v61/*: any*/),
  (v3/*: any*/)
],
v210 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v105/*: any*/),
    (v176/*: any*/)
  ],
  "storageKey": null
},
v211 = {
  "kind": "InlineFragment",
  "selections": [
    (v89/*: any*/),
    (v162/*: any*/)
  ],
  "type": "TeamHealthStage",
  "abstractKey": null
},
v212 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "localPhase",
  "plural": false,
  "selections": [
    (v61/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "stages",
      "plural": true,
      "selections": [
        (v61/*: any*/),
        (v3/*: any*/),
        (v78/*: any*/),
        (v79/*: any*/),
        (v52/*: any*/),
        (v157/*: any*/),
        (v136/*: any*/),
        (v74/*: any*/),
        (v73/*: any*/),
        (v111/*: any*/)
      ],
      "storageKey": null
    },
    (v165/*: any*/),
    (v111/*: any*/),
    (v166/*: any*/)
  ],
  "storageKey": null
},
v213 = {
  "kind": "InlineFragment",
  "selections": [
    (v104/*: any*/),
    (v31/*: any*/)
  ],
  "type": "EstimateStage",
  "abstractKey": null
},
v214 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v215 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraIssueField",
  "kind": "LinkedField",
  "name": "possibleEstimationFields",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fieldId",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v216 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "missingEstimationFieldHint",
  "storageKey": null
},
v217 = {
  "alias": "jiraUrl",
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v218 = {
  "alias": "jiraProjectId",
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
},
v219 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueType",
  "storageKey": null
},
v220 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "possibleEstimationFieldNames",
  "storageKey": null
},
v221 = {
  "alias": "ghUrl",
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v222 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
},
v223 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationHash",
  "storageKey": null
},
v224 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v159/*: any*/),
  "storageKey": null
},
v225 = {
  "alias": null,
  "args": null,
  "concreteType": "TemplateScaleRef",
  "kind": "LinkedField",
  "name": "scale",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TemplateScaleValue",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        (v106/*: any*/),
        (v26/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v226 = {
  "alias": null,
  "args": null,
  "concreteType": "TemplateDimensionRef",
  "kind": "LinkedField",
  "name": "dimensionRef",
  "plural": false,
  "selections": [
    (v225/*: any*/),
    (v3/*: any*/),
    (v105/*: any*/)
  ],
  "storageKey": null
},
v227 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "hoveringUsers",
  "plural": true,
  "selections": (v151/*: any*/),
  "storageKey": null
},
v228 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EstimateStage",
      "kind": "LinkedField",
      "name": "stages",
      "plural": true,
      "selections": [
        (v16/*: any*/),
        (v104/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "kind": "LinkedField",
          "name": "task",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "integration",
              "plural": false,
              "selections": [
                (v61/*: any*/),
                (v3/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v199/*: any*/),
                    (v195/*: any*/),
                    (v107/*: any*/),
                    (v214/*: any*/),
                    (v187/*: any*/)
                  ],
                  "type": "AzureDevOpsWorkItem",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v189/*: any*/),
                    (v188/*: any*/),
                    (v215/*: any*/),
                    (v216/*: any*/),
                    (v187/*: any*/),
                    (v217/*: any*/)
                  ],
                  "type": "JiraIssue",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v189/*: any*/),
                    (v188/*: any*/),
                    (v218/*: any*/),
                    (v219/*: any*/),
                    (v220/*: any*/),
                    (v187/*: any*/),
                    (v217/*: any*/)
                  ],
                  "type": "JiraServerIssue",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v192/*: any*/),
                    (v194/*: any*/),
                    (v191/*: any*/),
                    (v221/*: any*/)
                  ],
                  "type": "_xGitHubIssue",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v197/*: any*/),
                    (v222/*: any*/),
                    (v196/*: any*/),
                    (v198/*: any*/)
                  ],
                  "type": "_xGitLabIssue",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            (v3/*: any*/),
            (v223/*: any*/),
            (v64/*: any*/),
            (v8/*: any*/),
            (v55/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EstimateUserScore",
          "kind": "LinkedField",
          "name": "scores",
          "plural": true,
          "selections": [
            (v19/*: any*/),
            (v3/*: any*/),
            (v26/*: any*/),
            (v224/*: any*/)
          ],
          "storageKey": null
        },
        (v24/*: any*/),
        (v226/*: any*/),
        (v108/*: any*/),
        (v21/*: any*/),
        (v64/*: any*/),
        (v227/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "EstimatePhase",
  "abstractKey": null
},
v229 = [
  (v118/*: any*/),
  (v3/*: any*/)
],
v230 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientId",
  "storageKey": null
},
v231 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMemberIntegrationAuthOAuth2",
  "kind": "LinkedField",
  "name": "auth",
  "plural": false,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v232 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJQL",
  "storageKey": null
},
v233 = [
  (v3/*: any*/),
  (v118/*: any*/),
  (v232/*: any*/),
  (v121/*: any*/)
],
v234 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tenantId",
    "storageKey": null
  },
  (v230/*: any*/)
],
v235 = {
  "alias": null,
  "args": null,
  "concreteType": "PokerMeetingMember",
  "kind": "LinkedField",
  "name": "viewerMeetingMember",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "teamMember",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamMemberIntegrations",
          "kind": "LinkedField",
          "name": "integrations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GitHubIntegration",
              "kind": "LinkedField",
              "name": "github",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GitHubSearchQuery",
                  "kind": "LinkedField",
                  "name": "githubSearchQueries",
                  "plural": true,
                  "selections": (v229/*: any*/),
                  "storageKey": null
                },
                (v3/*: any*/),
                (v54/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "scope",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "GitLabIntegration",
              "kind": "LinkedField",
              "name": "gitlab",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationProviderOAuth2",
                  "kind": "LinkedField",
                  "name": "cloudProvider",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    (v230/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "serverBaseUrl",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "projects",
                  "plural": true,
                  "selections": [
                    (v61/*: any*/),
                    (v3/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fullPath",
                          "storageKey": null
                        }
                      ],
                      "type": "_xGitLabProject",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v231/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationProviderOAuth2",
                  "kind": "LinkedField",
                  "name": "sharedProviders",
                  "plural": true,
                  "selections": [
                    (v230/*: any*/),
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AtlassianIntegration",
              "kind": "LinkedField",
              "name": "atlassian",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JiraSearchQuery",
                  "kind": "LinkedField",
                  "name": "jiraSearchQueries",
                  "plural": true,
                  "selections": (v233/*: any*/),
                  "storageKey": null
                },
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JiraRemoteProject",
                  "kind": "LinkedField",
                  "name": "projects",
                  "plural": true,
                  "selections": (v133/*: any*/),
                  "storageKey": null
                },
                (v54/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JiraServerIntegration",
              "kind": "LinkedField",
              "name": "jiraServer",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TeamMemberIntegrationAuthOAuth1",
                  "kind": "LinkedField",
                  "name": "auth",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    (v54/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationProviderOAuth1",
                  "kind": "LinkedField",
                  "name": "sharedProviders",
                  "plural": true,
                  "selections": (v58/*: any*/),
                  "storageKey": null
                },
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JiraServerRemoteProject",
                  "kind": "LinkedField",
                  "name": "projects",
                  "plural": true,
                  "selections": (v133/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JiraSearchQuery",
                  "kind": "LinkedField",
                  "name": "searchQueries",
                  "plural": true,
                  "selections": (v233/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AzureDevOpsIntegration",
              "kind": "LinkedField",
              "name": "azureDevOps",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationProviderOAuth2",
                  "kind": "LinkedField",
                  "name": "cloudProvider",
                  "plural": false,
                  "selections": (v234/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationProviderOAuth2",
                  "kind": "LinkedField",
                  "name": "sharedProviders",
                  "plural": true,
                  "selections": (v234/*: any*/),
                  "storageKey": null
                },
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AzureDevOpsRemoteProject",
                  "kind": "LinkedField",
                  "name": "projects",
                  "plural": true,
                  "selections": (v133/*: any*/),
                  "storageKey": null
                },
                (v231/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v3/*: any*/),
        (v64/*: any*/)
      ],
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserFeatureFlags",
          "kind": "LinkedField",
          "name": "featureFlags",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "azureDevOps",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v17/*: any*/)
  ],
  "storageKey": null
},
v236 = {
  "alias": "init",
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v237 = {
  "alias": "init",
  "args": null,
  "filters": null,
  "handle": "localPoker",
  "key": "",
  "kind": "ScalarHandle",
  "name": "id"
},
v238 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "phases",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "stages",
      "plural": true,
      "selections": [
        (v136/*: any*/),
        (v74/*: any*/),
        (v73/*: any*/),
        (v111/*: any*/),
        (v153/*: any*/),
        (v85/*: any*/),
        (v154/*: any*/),
        (v155/*: any*/),
        (v84/*: any*/),
        (v86/*: any*/),
        (v157/*: any*/),
        (v158/*: any*/),
        (v164/*: any*/)
      ],
      "storageKey": null
    },
    (v165/*: any*/),
    (v166/*: any*/)
  ],
  "storageKey": null
},
v239 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "meetingMembers",
  "plural": true,
  "selections": [
    (v19/*: any*/),
    (v152/*: any*/)
  ],
  "storageKey": null
},
v240 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "facilitator",
  "plural": false,
  "selections": [
    (v109/*: any*/),
    (v60/*: any*/),
    (v170/*: any*/),
    (v3/*: any*/),
    (v64/*: any*/),
    (v169/*: any*/)
  ],
  "storageKey": null
},
v241 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "localStage",
      "plural": false,
      "selections": [
        (v61/*: any*/),
        (v3/*: any*/),
        (v136/*: any*/),
        (v78/*: any*/),
        (v74/*: any*/),
        (v73/*: any*/),
        (v111/*: any*/),
        (v153/*: any*/),
        (v85/*: any*/),
        (v154/*: any*/),
        (v155/*: any*/),
        (v84/*: any*/),
        (v86/*: any*/),
        (v163/*: any*/),
        (v158/*: any*/),
        (v211/*: any*/)
      ],
      "storageKey": null
    },
    (v212/*: any*/),
    (v178/*: any*/)
  ]
},
v242 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    (v199/*: any*/),
    (v107/*: any*/),
    (v214/*: any*/),
    (v195/*: any*/),
    (v187/*: any*/)
  ],
  "type": "AzureDevOpsWorkItem",
  "abstractKey": null
},
v243 = [
  (v189/*: any*/),
  (v188/*: any*/),
  (v187/*: any*/),
  (v217/*: any*/)
],
v244 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "localStage",
      "plural": false,
      "selections": [
        (v61/*: any*/),
        (v3/*: any*/),
        (v78/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v24/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TemplateDimensionRef",
              "kind": "LinkedField",
              "name": "dimensionRef",
              "plural": false,
              "selections": [
                (v225/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EstimateUserScore",
              "kind": "LinkedField",
              "name": "scores",
              "plural": true,
              "selections": [
                (v19/*: any*/),
                (v26/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            (v104/*: any*/),
            (v31/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Task",
              "kind": "LinkedField",
              "name": "task",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v6/*: any*/),
                (v8/*: any*/),
                (v55/*: any*/),
                (v64/*: any*/),
                (v223/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "integration",
                  "plural": false,
                  "selections": [
                    (v61/*: any*/),
                    (v3/*: any*/),
                    (v242/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": (v243/*: any*/),
                      "type": "JiraIssue",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v243/*: any*/),
                      "type": "JiraServerIssue",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v192/*: any*/),
                        (v6/*: any*/),
                        (v191/*: any*/),
                        (v221/*: any*/)
                      ],
                      "type": "_xGitHubIssue",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v196/*: any*/),
                        (v6/*: any*/),
                        (v198/*: any*/),
                        (v197/*: any*/)
                      ],
                      "type": "_xGitLabIssue",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "EstimateStage",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    (v178/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "localPhase",
      "plural": false,
      "selections": [
        (v61/*: any*/),
        (v111/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GitHubSearchQuery",
      "kind": "LinkedField",
      "name": "githubSearchQuery",
      "plural": false,
      "selections": (v229/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GitLabSearchQuery",
      "kind": "LinkedField",
      "name": "gitlabSearchQuery",
      "plural": false,
      "selections": [
        (v119/*: any*/),
        (v118/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JiraSearchQuery",
      "kind": "LinkedField",
      "name": "jiraSearchQuery",
      "plural": false,
      "selections": [
        (v118/*: any*/),
        (v232/*: any*/),
        (v3/*: any*/),
        (v121/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JiraSearchQuery",
      "kind": "LinkedField",
      "name": "jiraServerSearchQuery",
      "plural": false,
      "selections": [
        (v121/*: any*/),
        (v118/*: any*/),
        (v232/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ParabolSearchQuery",
      "kind": "LinkedField",
      "name": "parabolSearchQuery",
      "plural": false,
      "selections": [
        (v118/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusFilters",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AzureDevOpsSearchQuery",
      "kind": "LinkedField",
      "name": "azureDevOpsSearchQuery",
      "plural": false,
      "selections": [
        (v118/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isWIQL",
          "storageKey": null
        },
        (v3/*: any*/),
        (v121/*: any*/)
      ],
      "storageKey": null
    },
    (v179/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCommentUnread",
      "storageKey": null
    }
  ]
},
v245 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localStageId",
  "storageKey": null
},
v246 = [
  {
    "kind": "Literal",
    "name": "maxRepositories",
    "value": 100
  }
],
v247 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v248 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "occurredAt",
  "storageKey": null
},
v249 = {
  "alias": null,
  "args": null,
  "concreteType": "_xGitHubRepository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v193/*: any*/)
  ],
  "storageKey": null
},
v250 = {
  "alias": null,
  "args": null,
  "concreteType": "EstimateUserScore",
  "kind": "LinkedField",
  "name": "scores",
  "plural": true,
  "selections": [
    (v224/*: any*/),
    (v19/*: any*/),
    (v26/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v251 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "createdByUser",
  "plural": false,
  "selections": [
    (v60/*: any*/),
    (v3/*: any*/),
    (v109/*: any*/)
  ],
  "storageKey": null
},
v252 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isHighlighted",
  "storageKey": null
},
v253 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "replies",
      "plural": true,
      "selections": [
        (v61/*: any*/),
        (v3/*: any*/),
        (v32/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Threadable",
  "abstractKey": "__isThreadable"
},
v254 = [
  (v3/*: any*/),
  (v60/*: any*/),
  (v109/*: any*/)
],
v255 = {
  "alias": "createdByUserNullable",
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "createdByUser",
  "plural": false,
  "selections": (v254/*: any*/),
  "storageKey": null
},
v256 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewerComment",
  "storageKey": null
},
v257 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "replies",
  "plural": true,
  "selections": [
    (v61/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isThreadable"
    },
    (v3/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v55/*: any*/),
        (v186/*: any*/),
        (v251/*: any*/),
        (v200/*: any*/),
        (v201/*: any*/),
        (v202/*: any*/),
        (v203/*: any*/),
        (v134/*: any*/),
        (v19/*: any*/),
        (v252/*: any*/),
        (v126/*: any*/),
        (v93/*: any*/),
        (v204/*: any*/),
        (v205/*: any*/),
        (v64/*: any*/),
        (v33/*: any*/),
        (v206/*: any*/),
        (v253/*: any*/)
      ],
      "type": "Task",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v255/*: any*/),
        (v54/*: any*/),
        (v256/*: any*/),
        (v141/*: any*/),
        (v93/*: any*/),
        (v55/*: any*/),
        (v33/*: any*/),
        (v253/*: any*/)
      ],
      "type": "Comment",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v258 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "replies",
      "plural": true,
      "selections": [
        (v32/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Threadable",
  "abstractKey": "__isThreadable"
},
v259 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "createdByUser",
  "plural": false,
  "selections": (v254/*: any*/),
  "storageKey": null
},
v260 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "unlockedStages",
  "plural": true,
  "selections": [
    (v61/*: any*/),
    (v3/*: any*/),
    (v52/*: any*/)
  ],
  "storageKey": null
},
v261 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "meeting",
  "plural": false,
  "selections": (v209/*: any*/),
  "storageKey": null
},
v262 = [
  (v139/*: any*/),
  (v46/*: any*/),
  (v3/*: any*/),
  (v21/*: any*/),
  (v11/*: any*/),
  (v10/*: any*/),
  (v55/*: any*/),
  (v141/*: any*/),
  (v36/*: any*/),
  (v143/*: any*/),
  (v145/*: any*/)
],
v263 = [
  (v188/*: any*/),
  (v3/*: any*/)
],
v264 = {
  "kind": "InlineFragment",
  "selections": [
    (v61/*: any*/),
    (v188/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        (v149/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationFeatureFlags",
          "kind": "LinkedField",
          "name": "featureFlags",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "standupAISummary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "noAISummary",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "sortBy",
              "value": "voteCount"
            }
          ],
          "concreteType": "RetroReflectionGroup",
          "kind": "LinkedField",
          "name": "reflectionGroups",
          "plural": true,
          "selections": (v263/*: any*/),
          "storageKey": "reflectionGroups(sortBy:\"voteCount\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "phases",
          "plural": true,
          "selections": [
            (v61/*: any*/),
            (v111/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RetroDiscussStage",
                  "kind": "LinkedField",
                  "name": "stages",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Discussion",
                      "kind": "LinkedField",
                      "name": "discussion",
                      "plural": false,
                      "selections": (v263/*: any*/),
                      "storageKey": null
                    },
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "type": "DiscussPhase",
              "abstractKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "RetrospectiveMeeting",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamPromptResponse",
          "kind": "LinkedField",
          "name": "responses",
          "plural": true,
          "selections": (v58/*: any*/),
          "storageKey": null
        }
      ],
      "type": "TeamPromptMeeting",
      "abstractKey": null
    }
  ],
  "type": "NewMeeting",
  "abstractKey": "__isNewMeeting"
},
v265 = [
  (v80/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MeetingSubscriptionPayload",
        "kind": "LinkedField",
        "name": "meetingSubscription",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AddTranscriptionBotSuccess",
            "kind": "LinkedField",
            "name": "AddTranscriptionBotSuccess",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AddTranscriptionBotMutation_meeting"
              }
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GenerateGroupsSuccess",
            "kind": "LinkedField",
            "name": "GenerateGroupsSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SetTaskEstimateSuccess",
            "kind": "LinkedField",
            "name": "SetTaskEstimateSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SetPokerSpectateSuccess",
            "kind": "LinkedField",
            "name": "SetPokerSpectateSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PokerMeetingMember",
                "kind": "LinkedField",
                "name": "meetingMember",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "updatedStages",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EstimateUserScore",
                    "kind": "LinkedField",
                    "name": "scores",
                    "plural": true,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "JoinMeetingSuccess",
            "kind": "LinkedField",
            "name": "JoinMeetingSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MeetingSelector_meeting"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MeetingCard_meeting"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PokerAnnounceDeckHoverSuccess",
            "kind": "LinkedField",
            "name": "PokerAnnounceDeckHoverSuccess",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AvatarListUser_user"
                  }
                ],
                "storageKey": null
              },
              (v22/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PokerResetDimensionSuccess",
            "kind": "LinkedField",
            "name": "PokerResetDimensionSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v24/*: any*/),
                  (v27/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PokerRevealVotesSuccess",
            "kind": "LinkedField",
            "name": "PokerRevealVotesSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EstimateUserScore",
                    "kind": "LinkedField",
                    "name": "scores",
                    "plural": true,
                    "selections": [
                      (v25/*: any*/),
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VoteForPokerStorySuccess",
            "kind": "LinkedField",
            "name": "VoteForPokerStorySuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v27/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddReactjiToReactableSuccess",
            "kind": "LinkedField",
            "name": "AddReactjiToReactableSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "reactable",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Reactji",
                    "kind": "LinkedField",
                    "name": "reactjis",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ReactjiCount_reactji"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddCommentSuccess",
            "kind": "LinkedField",
            "name": "AddCommentSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "comment",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/)
                ],
                "storageKey": null
              },
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CreatePollSuccess",
            "kind": "LinkedField",
            "name": "CreatePollSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Poll",
                "kind": "LinkedField",
                "name": "poll",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v3/*: any*/),
                  (v35/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CreateReflectionPayload",
            "kind": "LinkedField",
            "name": "CreateReflectionPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetroReflectionGroup",
                "kind": "LinkedField",
                "name": "reflectionGroup",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v36/*: any*/),
                  (v10/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReflectionGroupTitleEditor_reflectionGroup"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReflectionGroupVoting_reflectionGroup"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetroReflection",
                    "kind": "LinkedField",
                    "name": "reflections",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "DraggableReflectionCard_reflection"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "DraggableReflectionCard_staticReflections"
                      },
                      (v37/*: any*/),
                      (v10/*: any*/),
                      (v36/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          (v38/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RemoteReflectionDrag",
                            "kind": "LinkedField",
                            "name": "remoteDrag",
                            "plural": false,
                            "selections": [
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              (v44/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      (v45/*: any*/),
                      (v46/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v47/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReflectionGroupHeader_reflectionGroup"
                  },
                  (v48/*: any*/),
                  (v6/*: any*/),
                  (v50/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReflectionGroup_reflectionGroup"
                  },
                  (v51/*: any*/)
                ],
                "storageKey": null
              },
              (v53/*: any*/)
            ],
            "storageKey": null
          },
          (v56/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DragDiscussionTopicPayload",
            "kind": "LinkedField",
            "name": "DragDiscussionTopicPayload",
            "plural": false,
            "selections": [
              (v57/*: any*/),
              (v59/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EditCommentingSuccess",
            "kind": "LinkedField",
            "name": "EditCommentingSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Discussion",
                "kind": "LinkedField",
                "name": "discussion",
                "plural": false,
                "selections": [
                  (v62/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v63/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EndDraggingReflectionPayload",
            "kind": "LinkedField",
            "name": "EndDraggingReflectionPayload",
            "plural": false,
            "selections": [
              (v65/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RetroReflection",
                "kind": "LinkedField",
                "name": "reflection",
                "plural": false,
                "selections": (v66/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RetroReflectionGroup",
                "kind": "LinkedField",
                "name": "reflectionGroup",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v21/*: any*/),
                  (v36/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetroReflection",
                    "kind": "LinkedField",
                    "name": "reflections",
                    "plural": true,
                    "selections": (v66/*: any*/),
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v51/*: any*/)
                ],
                "storageKey": null
              },
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v19/*: any*/),
              (v70/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EndRetrospectiveSuccess",
            "kind": "LinkedField",
            "name": "EndRetrospectiveSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v71/*: any*/),
                  (v72/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EndTeamPromptSuccess",
            "kind": "LinkedField",
            "name": "EndTeamPromptSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamPromptMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v71/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FlagReadyToAdvanceSuccess",
            "kind": "LinkedField",
            "name": "FlagReadyToAdvanceSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v73/*: any*/),
                  (v74/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PromoteNewMeetingFacilitatorPayload",
            "kind": "LinkedField",
            "name": "PromoteNewMeetingFacilitatorPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v75/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "facilitator",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "StageTimerModalEndTimeSlackToggle_facilitator"
                      },
                      (v19/*: any*/),
                      (v60/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "oldFacilitator",
                "plural": false,
                "selections": [
                  (v76/*: any*/),
                  (v60/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "facilitatorStage",
                "plural": false,
                "selections": [
                  (v74/*: any*/),
                  (v73/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveReflectionPayload",
            "kind": "LinkedField",
            "name": "RemoveReflectionPayload",
            "plural": false,
            "selections": [
              (v59/*: any*/),
              (v77/*: any*/),
              (v53/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ResetRetroMeetingToGroupStagePayload",
            "kind": "LinkedField",
            "name": "ResetRetroMeetingToGroupStagePayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "stages",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v78/*: any*/),
                          (v79/*: any*/),
                          (v52/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v81/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MeetingControlBar_meeting"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RevealTeamHealthVotesSuccess",
            "kind": "LinkedField",
            "name": "RevealTeamHealthVotesSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamHealthStage",
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v82/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SetPhaseFocusPayload",
            "kind": "LinkedField",
            "name": "SetPhaseFocusPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReflectPhase",
                "kind": "LinkedField",
                "name": "reflectPhase",
                "plural": false,
                "selections": [
                  (v83/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SetStageTimerPayload",
            "kind": "LinkedField",
            "name": "SetStageTimerPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v84/*: any*/),
                  (v85/*: any*/),
                  (v86/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SetTeamHealthVoteSuccess",
            "kind": "LinkedField",
            "name": "SetTeamHealthVoteSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamHealthStage",
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v87/*: any*/),
                  (v88/*: any*/),
                  (v89/*: any*/),
                  (v82/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v90/*: any*/),
          (v92/*: any*/),
          (v94/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateNewCheckInQuestionPayload",
            "kind": "LinkedField",
            "name": "UpdateNewCheckInQuestionPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v96/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v103/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdatePokerScopeSuccess",
            "kind": "LinkedField",
            "name": "UpdatePokerScopeSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "newStages",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useMakeStageSummaries_stages"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PokerEstimateHeaderCard_stage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PokerCardDeckStage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EstimatePhaseAreaStage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "JiraFieldDimensionDropdown_stage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EstimateDimensionColumn_stage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EstimatePhaseDiscussionDrawerEstimateStage"
                  },
                  (v3/*: any*/),
                  (v52/*: any*/),
                  (v24/*: any*/),
                  (v104/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TemplateDimensionRef",
                    "kind": "LinkedField",
                    "name": "dimensionRef",
                    "plural": false,
                    "selections": [
                      (v105/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TemplateScaleRef",
                        "kind": "LinkedField",
                        "name": "scale",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateScaleValue",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": true,
                            "selections": [
                              (v106/*: any*/),
                              (v26/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v108/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EstimateUserScore",
                    "kind": "LinkedField",
                    "name": "scores",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      (v26/*: any*/),
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v109/*: any*/),
                          (v60/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PokerMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PokerMeeting_meeting"
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "useInitialSafeRoute_meeting",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v113/*: any*/),
                          (v114/*: any*/),
                          (v3/*: any*/),
                          (v115/*: any*/),
                          (v110/*: any*/),
                          (v75/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v111/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v79/*: any*/),
                                  (v52/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v117/*: any*/)
                        ],
                        "type": "NewMeeting",
                        "abstractKey": "__isNewMeeting"
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "useUpdatedSafeRoute_meeting",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v113/*: any*/),
                          (v114/*: any*/),
                          (v3/*: any*/),
                          (v110/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": (v116/*: any*/),
                            "storageKey": null
                          },
                          (v117/*: any*/)
                        ],
                        "type": "NewMeeting",
                        "abstractKey": "__isNewMeeting"
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EstimateStage",
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": (v58/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "EstimatePhase",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GitLabSearchQuery",
                        "kind": "LinkedField",
                        "name": "gitlabSearchQuery",
                        "plural": false,
                        "selections": [
                          (v118/*: any*/),
                          (v119/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GitHubSearchQuery",
                        "kind": "LinkedField",
                        "name": "githubSearchQuery",
                        "plural": false,
                        "selections": (v120/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JiraSearchQuery",
                        "kind": "LinkedField",
                        "name": "jiraSearchQuery",
                        "plural": false,
                        "selections": [
                          (v118/*: any*/),
                          (v121/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ParabolSearchQuery",
                        "kind": "LinkedField",
                        "name": "parabolSearchQuery",
                        "plural": false,
                        "selections": (v120/*: any*/),
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateReflectionContentPayload",
            "kind": "LinkedField",
            "name": "UpdateReflectionContentPayload",
            "plural": false,
            "selections": [
              (v59/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RetroReflection",
                "kind": "LinkedField",
                "name": "reflection",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v55/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetroReflectionGroup",
                    "kind": "LinkedField",
                    "name": "retroReflectionGroup",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateReflectionGroupTitlePayload",
            "kind": "LinkedField",
            "name": "UpdateReflectionGroupTitlePayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetroReflectionGroup",
                "kind": "LinkedField",
                "name": "reflectionGroup",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v48/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateRetroMaxVotesSuccess",
            "kind": "LinkedField",
            "name": "UpdateRetroMaxVotesSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v122/*: any*/),
                  (v123/*: any*/),
                  (v80/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetrospectiveMeetingMember",
                    "kind": "LinkedField",
                    "name": "viewerMeetingMember",
                    "plural": false,
                    "selections": (v124/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VoteForReflectionGroupPayload",
            "kind": "LinkedField",
            "name": "VoteForReflectionGroupPayload",
            "plural": false,
            "selections": [
              (v125/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": (v124/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeetingMember",
                "kind": "LinkedField",
                "name": "meetingMember",
                "plural": false,
                "selections": (v124/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RetroReflectionGroup",
                "kind": "LinkedField",
                "name": "reflectionGroup",
                "plural": false,
                "selections": [
                  (v47/*: any*/),
                  (v51/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpsertTeamPromptResponseSuccess",
            "kind": "LinkedField",
            "name": "UpsertTeamPromptResponseSuccess",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamPromptResponse",
                "kind": "LinkedField",
                "name": "teamPromptResponse",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v19/*: any*/),
                  (v55/*: any*/),
                  (v8/*: any*/),
                  (v93/*: any*/),
                  (v126/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TeamPromptResponseEmojis_response"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MeetingSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MeetingSubscriptionPayload",
        "kind": "LinkedField",
        "name": "meetingSubscription",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AddTranscriptionBotSuccess",
            "kind": "LinkedField",
            "name": "AddTranscriptionBotSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v127/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GenerateGroupsSuccess",
            "kind": "LinkedField",
            "name": "GenerateGroupsSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SetTaskEstimateSuccess",
            "kind": "LinkedField",
            "name": "SetTaskEstimateSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SetPokerSpectateSuccess",
            "kind": "LinkedField",
            "name": "SetPokerSpectateSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PokerMeetingMember",
                "kind": "LinkedField",
                "name": "meetingMember",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "updatedStages",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EstimateUserScore",
                    "kind": "LinkedField",
                    "name": "scores",
                    "plural": true,
                    "selections": (v128/*: any*/),
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "JoinMeetingSuccess",
            "kind": "LinkedField",
            "name": "JoinMeetingSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v61/*: any*/),
                  (v129/*: any*/),
                  (v115/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "meetingMembers",
                    "plural": true,
                    "selections": [
                      (v61/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v109/*: any*/),
                          (v60/*: any*/),
                          (v76/*: any*/),
                          (v130/*: any*/),
                          (v131/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v105/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v61/*: any*/),
                      (v111/*: any*/),
                      (v132/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v134/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v135/*: any*/),
                      (v110/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "phases",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              (v79/*: any*/),
                              (v52/*: any*/),
                              (v74/*: any*/),
                              (v111/*: any*/),
                              (v136/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RetroReflectionGroup",
                                    "kind": "LinkedField",
                                    "name": "reflectionGroup",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RetroReflection",
                                        "kind": "LinkedField",
                                        "name": "reflections",
                                        "plural": true,
                                        "selections": [
                                          (v139/*: any*/),
                                          (v46/*: any*/),
                                          (v3/*: any*/),
                                          (v21/*: any*/),
                                          (v11/*: any*/),
                                          (v10/*: any*/),
                                          (v55/*: any*/),
                                          (v141/*: any*/),
                                          (v36/*: any*/),
                                          (v143/*: any*/),
                                          (v145/*: any*/),
                                          (v8/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v3/*: any*/),
                                      (v6/*: any*/),
                                      (v47/*: any*/),
                                      (v10/*: any*/),
                                      (v36/*: any*/),
                                      (v48/*: any*/),
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          (v49/*: any*/)
                                        ]
                                      },
                                      (v51/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v31/*: any*/)
                                ],
                                "type": "RetroDiscussStage",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RetroDiscussStage",
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RetroReflectionGroup",
                                    "kind": "LinkedField",
                                    "name": "reflectionGroup",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v51/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v36/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "DiscussPhase",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v83/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReflectPrompt",
                                "kind": "LinkedField",
                                "name": "reflectPrompts",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v146/*: any*/),
                                  (v138/*: any*/),
                                  (v137/*: any*/),
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      (v147/*: any*/)
                                    ]
                                  },
                                  (v36/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ReflectPhase",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v75/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetrospectiveMeetingMember",
                        "kind": "LinkedField",
                        "name": "meetingMembers",
                        "plural": true,
                        "selections": (v20/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "disableAnonymity",
                        "storageKey": null
                      },
                      (v64/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetrospectiveMeetingMember",
                        "kind": "LinkedField",
                        "name": "viewerMeetingMember",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": (v142/*: any*/),
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v80/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetroReflectionGroup",
                        "kind": "LinkedField",
                        "name": "reflectionGroups",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v47/*: any*/),
                          (v148/*: any*/),
                          (v10/*: any*/),
                          (v36/*: any*/),
                          (v48/*: any*/),
                          (v50/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v123/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "meetingNumber",
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organization",
                        "kind": "LinkedField",
                        "name": "organization",
                        "plural": false,
                        "selections": [
                          (v149/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrganizationFeatureFlags",
                            "kind": "LinkedField",
                            "name": "featureFlags",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "suggestGroups",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "zoomTranscription",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrgUserCount",
                            "kind": "LinkedField",
                            "name": "orgUserCount",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "activeUserCount",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v122/*: any*/),
                      (v80/*: any*/),
                      (v150/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "showConversionModal",
                        "storageKey": null
                      },
                      (v127/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TranscriptBlock",
                        "kind": "LinkedField",
                        "name": "transcription",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "speaker",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "words",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "meetingMembers",
                            "plural": true,
                            "selections": [
                              (v152/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  (v73/*: any*/),
                                  (v153/*: any*/),
                                  (v85/*: any*/),
                                  (v154/*: any*/),
                                  (v155/*: any*/),
                                  (v84/*: any*/),
                                  (v86/*: any*/),
                                  (v157/*: any*/),
                                  (v158/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v88/*: any*/),
                                      (v160/*: any*/),
                                      (v137/*: any*/),
                                      (v87/*: any*/),
                                      (v89/*: any*/),
                                      (v161/*: any*/),
                                      (v162/*: any*/)
                                    ],
                                    "type": "TeamHealthStage",
                                    "abstractKey": null
                                  },
                                  (v164/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v165/*: any*/),
                              (v166/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "facilitator",
                            "plural": false,
                            "selections": [
                              (v64/*: any*/),
                              (v169/*: any*/),
                              (v109/*: any*/),
                              (v170/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v171/*: any*/),
                          (v174/*: any*/),
                          (v175/*: any*/),
                          (v177/*: any*/),
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "localStage",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/),
                                  (v136/*: any*/),
                                  (v3/*: any*/),
                                  (v78/*: any*/),
                                  (v74/*: any*/),
                                  (v73/*: any*/),
                                  (v111/*: any*/),
                                  (v153/*: any*/),
                                  (v85/*: any*/),
                                  (v154/*: any*/),
                                  (v155/*: any*/),
                                  (v84/*: any*/),
                                  (v86/*: any*/),
                                  (v163/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v89/*: any*/),
                                      (v162/*: any*/),
                                      (v88/*: any*/),
                                      (v160/*: any*/),
                                      (v137/*: any*/),
                                      (v87/*: any*/),
                                      (v161/*: any*/)
                                    ],
                                    "type": "TeamHealthStage",
                                    "abstractKey": null
                                  },
                                  (v158/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "localPhase",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "stages",
                                    "plural": true,
                                    "selections": [
                                      (v61/*: any*/),
                                      (v136/*: any*/),
                                      (v3/*: any*/),
                                      (v78/*: any*/),
                                      (v74/*: any*/),
                                      (v73/*: any*/),
                                      (v111/*: any*/),
                                      (v79/*: any*/),
                                      (v52/*: any*/),
                                      (v157/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*: any*/),
                                  (v111/*: any*/),
                                  (v165/*: any*/),
                                  (v166/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v178/*: any*/)
                            ]
                          },
                          (v180/*: any*/)
                        ],
                        "type": "NewMeeting",
                        "abstractKey": "__isNewMeeting"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "localStage",
                            "plural": false,
                            "selections": [
                              (v61/*: any*/),
                              (v3/*: any*/),
                              (v78/*: any*/),
                              (v111/*: any*/),
                              (v136/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RetroReflectionGroup",
                                    "kind": "LinkedField",
                                    "name": "reflectionGroup",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RetroReflection",
                                        "kind": "LinkedField",
                                        "name": "reflections",
                                        "plural": true,
                                        "selections": [
                                          (v139/*: any*/),
                                          (v46/*: any*/),
                                          (v3/*: any*/),
                                          (v40/*: any*/),
                                          (v21/*: any*/),
                                          (v11/*: any*/),
                                          (v10/*: any*/),
                                          (v55/*: any*/),
                                          (v141/*: any*/),
                                          (v36/*: any*/),
                                          (v143/*: any*/),
                                          (v39/*: any*/),
                                          (v144/*: any*/),
                                          (v38/*: any*/),
                                          (v8/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v3/*: any*/),
                                      (v6/*: any*/),
                                      (v47/*: any*/),
                                      (v10/*: any*/),
                                      (v36/*: any*/),
                                      (v48/*: any*/),
                                      (v49/*: any*/),
                                      (v51/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v31/*: any*/)
                                ],
                                "type": "RetroDiscussStage",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v178/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "localPhase",
                            "plural": false,
                            "selections": [
                              (v61/*: any*/),
                              (v111/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v83/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReflectPrompt",
                                    "kind": "LinkedField",
                                    "name": "reflectPrompts",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v146/*: any*/),
                                      (v147/*: any*/),
                                      (v138/*: any*/),
                                      (v137/*: any*/),
                                      (v36/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "ReflectPhase",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RetroReflectionGroup",
                            "kind": "LinkedField",
                            "name": "spotlightGroup",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RetroReflection",
                                "kind": "LinkedField",
                                "name": "reflections",
                                "plural": true,
                                "selections": [
                                  (v38/*: any*/),
                                  (v3/*: any*/),
                                  (v139/*: any*/),
                                  (v46/*: any*/),
                                  (v40/*: any*/),
                                  (v21/*: any*/),
                                  (v11/*: any*/),
                                  (v10/*: any*/),
                                  (v55/*: any*/),
                                  (v141/*: any*/),
                                  (v36/*: any*/),
                                  (v143/*: any*/),
                                  (v39/*: any*/),
                                  (v144/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              (v47/*: any*/),
                              (v10/*: any*/),
                              (v36/*: any*/),
                              (v48/*: any*/),
                              (v49/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "spotlightSearchQuery",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "spotlightReflectionId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isViewerDragInProgress",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showTranscription",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "type": "RetrospectiveMeeting",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v135/*: any*/),
                      (v110/*: any*/),
                      (v75/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "phases",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              (v79/*: any*/),
                              (v52/*: any*/),
                              (v181/*: any*/),
                              (v182/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v165/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgendaItemsStage",
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AgendaItem",
                                    "kind": "LinkedField",
                                    "name": "agendaItem",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v55/*: any*/),
                                      (v183/*: any*/),
                                      (v184/*: any*/),
                                      (v36/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AgendaItemsPhase",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "team",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AgendaItem",
                            "kind": "LinkedField",
                            "name": "agendaItems",
                            "plural": true,
                            "selections": [
                              (v36/*: any*/),
                              (v3/*: any*/),
                              (v55/*: any*/),
                              (v183/*: any*/),
                              (v184/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v185/*: any*/),
                            "concreteType": "TaskConnection",
                            "kind": "LinkedField",
                            "name": "tasks",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaskEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Task",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v61/*: any*/),
                                      (v36/*: any*/),
                                      (v55/*: any*/),
                                      (v186/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "createdByUser",
                                        "plural": false,
                                        "selections": (v142/*: any*/),
                                        "storageKey": null
                                      },
                                      (v200/*: any*/),
                                      (v201/*: any*/),
                                      (v202/*: any*/),
                                      (v203/*: any*/),
                                      (v134/*: any*/),
                                      (v19/*: any*/),
                                      (v91/*: any*/),
                                      (v126/*: any*/),
                                      (v93/*: any*/),
                                      (v204/*: any*/),
                                      (v205/*: any*/),
                                      (v64/*: any*/),
                                      (v206/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v207/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfoDateCursor",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": (v208/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": "tasks(first:1000)"
                          },
                          {
                            "alias": null,
                            "args": (v185/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "TeamColumnsContainer_tasks",
                            "kind": "LinkedHandle",
                            "name": "tasks"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ActionMeetingMember",
                        "kind": "LinkedField",
                        "name": "meetingMembers",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "teamMember",
                            "plural": false,
                            "selections": [
                              (v60/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isSelf",
                                "storageKey": null
                              },
                              (v109/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v150/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  (v136/*: any*/),
                                  (v74/*: any*/),
                                  (v73/*: any*/),
                                  (v111/*: any*/),
                                  (v153/*: any*/),
                                  (v85/*: any*/),
                                  (v155/*: any*/),
                                  (v84/*: any*/),
                                  (v157/*: any*/),
                                  (v158/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v166/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v64/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "viewerMeetingMember",
                            "plural": false,
                            "selections": (v209/*: any*/),
                            "storageKey": null
                          },
                          (v174/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "meetingMembers",
                            "plural": true,
                            "selections": (v20/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "facilitator",
                            "plural": false,
                            "selections": [
                              (v109/*: any*/),
                              (v170/*: any*/),
                              (v64/*: any*/),
                              (v169/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v175/*: any*/),
                          (v210/*: any*/),
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "localStage",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/),
                                  (v3/*: any*/),
                                  (v136/*: any*/),
                                  (v78/*: any*/),
                                  (v74/*: any*/),
                                  (v73/*: any*/),
                                  (v111/*: any*/),
                                  (v153/*: any*/),
                                  (v85/*: any*/),
                                  (v155/*: any*/),
                                  (v84/*: any*/),
                                  (v158/*: any*/),
                                  (v211/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v212/*: any*/),
                              (v178/*: any*/)
                            ]
                          },
                          (v180/*: any*/)
                        ],
                        "type": "NewMeeting",
                        "abstractKey": "__isNewMeeting"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "localPhase",
                            "plural": false,
                            "selections": [
                              (v61/*: any*/),
                              (v111/*: any*/),
                              (v3/*: any*/),
                              (v132/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AgendaItemsStage",
                                    "kind": "LinkedField",
                                    "name": "stages",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AgendaItem",
                                        "kind": "LinkedField",
                                        "name": "agendaItem",
                                        "plural": false,
                                        "selections": (v58/*: any*/),
                                        "storageKey": null
                                      },
                                      (v79/*: any*/),
                                      (v52/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "AgendaItemsPhase",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "localStage",
                            "plural": false,
                            "selections": [
                              (v61/*: any*/),
                              (v3/*: any*/),
                              (v181/*: any*/),
                              (v182/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v178/*: any*/)
                        ]
                      }
                    ],
                    "type": "ActionMeeting",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v135/*: any*/),
                      (v110/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "phases",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              (v79/*: any*/),
                              (v52/*: any*/),
                              (v213/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v228/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v75/*: any*/),
                      (v64/*: any*/),
                      (v235/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PokerMeetingMember",
                        "kind": "LinkedField",
                        "name": "meetingMembers",
                        "plural": true,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      },
                      (v236/*: any*/),
                      (v237/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v238/*: any*/),
                          (v171/*: any*/),
                          (v174/*: any*/),
                          (v239/*: any*/),
                          (v240/*: any*/),
                          (v175/*: any*/),
                          (v210/*: any*/),
                          (v241/*: any*/),
                          (v180/*: any*/)
                        ],
                        "type": "NewMeeting",
                        "abstractKey": "__isNewMeeting"
                      },
                      (v244/*: any*/)
                    ],
                    "type": "PokerMeeting",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v64/*: any*/),
                      (v75/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamPromptMeeting",
                        "kind": "LinkedField",
                        "name": "prevMeeting",
                        "plural": false,
                        "selections": (v58/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamPromptMeeting",
                        "kind": "LinkedField",
                        "name": "nextMeeting",
                        "plural": false,
                        "selections": (v58/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingSeries",
                        "kind": "LinkedField",
                        "name": "meetingSeries",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cancelledAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "recurrenceRule",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "activeMeetings",
                            "plural": true,
                            "selections": [
                              (v61/*: any*/),
                              (v3/*: any*/),
                              (v126/*: any*/),
                              (v85/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v135/*: any*/),
                      (v85/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "phases",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v31/*: any*/),
                                  (v152/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamPromptResponse",
                                    "kind": "LinkedField",
                                    "name": "response",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v55/*: any*/),
                                      (v93/*: any*/),
                                      (v126/*: any*/),
                                      (v141/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "TeamPromptResponseStage",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamPromptResponseStage",
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamMember",
                                    "kind": "LinkedField",
                                    "name": "teamMember",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      (v3/*: any*/),
                                      (v109/*: any*/),
                                      (v60/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamPromptResponse",
                                    "kind": "LinkedField",
                                    "name": "response",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v8/*: any*/),
                                      (v126/*: any*/),
                                      (v19/*: any*/),
                                      (v55/*: any*/),
                                      (v93/*: any*/),
                                      (v141/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v64/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "meeting",
                                    "plural": false,
                                    "selections": [
                                      (v61/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v135/*: any*/),
                                          {
                                            "kind": "ClientExtension",
                                            "selections": [
                                              (v245/*: any*/),
                                              (v179/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "TeamPromptMeeting",
                                        "abstractKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Discussion",
                                    "kind": "LinkedField",
                                    "name": "discussion",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": (v185/*: any*/),
                                        "concreteType": "ThreadableConnection",
                                        "kind": "LinkedField",
                                        "name": "thread",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ThreadableEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v61/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "User",
                                                    "kind": "LinkedField",
                                                    "name": "createdByUser",
                                                    "plural": false,
                                                    "selections": (v159/*: any*/),
                                                    "storageKey": null
                                                  },
                                                  (v3/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v207/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": (v208/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "thread(first:1000)"
                                      },
                                      {
                                        "alias": null,
                                        "args": (v185/*: any*/),
                                        "filters": null,
                                        "handle": "connection",
                                        "key": "DiscussionThread_thread",
                                        "kind": "LinkedHandle",
                                        "name": "thread"
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TeamPromptResponsesPhase",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamPromptMeetingMember",
                        "kind": "LinkedField",
                        "name": "viewerMeetingMember",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserFeatureFlags",
                                "kind": "LinkedField",
                                "name": "featureFlags",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "gcal",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "teamMember",
                            "plural": false,
                            "selections": [
                              (v64/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamMemberIntegrations",
                                "kind": "LinkedField",
                                "name": "integrations",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GitHubIntegration",
                                    "kind": "LinkedField",
                                    "name": "github",
                                    "plural": false,
                                    "selections": [
                                      (v54/*: any*/),
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "_xGitHubApi",
                                        "kind": "LinkedField",
                                        "name": "api",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "_xGitHubQuery",
                                            "kind": "LinkedField",
                                            "name": "query",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "_xGitHubUser",
                                                "kind": "LinkedField",
                                                "name": "viewer",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "_xGitHubContributionsCollection",
                                                    "kind": "LinkedField",
                                                    "name": "contributionsCollection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": (v246/*: any*/),
                                                        "concreteType": "_xGitHubCommitContributionsByRepository",
                                                        "kind": "LinkedField",
                                                        "name": "commitContributionsByRepository",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": [
                                                              (v247/*: any*/),
                                                              {
                                                                "kind": "Literal",
                                                                "name": "orderBy",
                                                                "value": {
                                                                  "direction": "DESC",
                                                                  "field": "OCCURRED_AT"
                                                                }
                                                              }
                                                            ],
                                                            "concreteType": "_xGitHubCreatedCommitContributionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "contributions",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "_xGitHubCreatedCommitContribution",
                                                                "kind": "LinkedField",
                                                                "name": "nodes",
                                                                "plural": true,
                                                                "selections": [
                                                                  (v248/*: any*/),
                                                                  (v249/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": "contributions(first:1,orderBy:{\"direction\":\"DESC\",\"field\":\"OCCURRED_AT\"})"
                                                          }
                                                        ],
                                                        "storageKey": "commitContributionsByRepository(maxRepositories:100)"
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": (v246/*: any*/),
                                                        "concreteType": "_xGitHubIssueContributionsByRepository",
                                                        "kind": "LinkedField",
                                                        "name": "issueContributionsByRepository",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": [
                                                              (v247/*: any*/),
                                                              {
                                                                "kind": "Literal",
                                                                "name": "orderBy",
                                                                "value": {
                                                                  "direction": "DESC"
                                                                }
                                                              }
                                                            ],
                                                            "concreteType": "_xGitHubCreatedIssueContributionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "contributions",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "_xGitHubCreatedIssueContributionEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "_xGitHubCreatedIssueContribution",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v248/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": "contributions(first:1,orderBy:{\"direction\":\"DESC\"})"
                                                          },
                                                          (v249/*: any*/)
                                                        ],
                                                        "storageKey": "issueContributionsByRepository(maxRepositories:100)"
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v3/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AtlassianIntegration",
                                    "kind": "LinkedField",
                                    "name": "atlassian",
                                    "plural": false,
                                    "selections": (v167/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GcalIntegration",
                                    "kind": "LinkedField",
                                    "name": "gcal",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TeamMemberIntegrationAuthOAuth2",
                                        "kind": "LinkedField",
                                        "name": "auth",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "providerId",
                                            "storageKey": null
                                          },
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "IntegrationProviderOAuth2",
                                        "kind": "LinkedField",
                                        "name": "cloudProvider",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v230/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organization",
                        "kind": "LinkedField",
                        "name": "organization",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrganizationFeatureFlags",
                            "kind": "LinkedField",
                            "name": "featureFlags",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "singleColumnStandups",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v110/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  (v79/*: any*/),
                                  (v52/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v171/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Team",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": [
                              (v173/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v239/*: any*/),
                          (v175/*: any*/),
                          (v177/*: any*/),
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "localStage",
                                "plural": false,
                                "selections": (v209/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "localPhase",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/),
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "stages",
                                    "plural": true,
                                    "selections": (v209/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v178/*: any*/)
                            ]
                          }
                        ],
                        "type": "NewMeeting",
                        "abstractKey": "__isNewMeeting"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          (v179/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showWorkSidebar",
                            "storageKey": null
                          },
                          (v245/*: any*/)
                        ]
                      }
                    ],
                    "type": "TeamPromptMeeting",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PokerAnnounceDeckHoverSuccess",
            "kind": "LinkedField",
            "name": "PokerAnnounceDeckHoverSuccess",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              (v224/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PokerResetDimensionSuccess",
            "kind": "LinkedField",
            "name": "PokerResetDimensionSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v24/*: any*/),
                  (v250/*: any*/),
                  (v16/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PokerRevealVotesSuccess",
            "kind": "LinkedField",
            "name": "PokerRevealVotesSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EstimateUserScore",
                    "kind": "LinkedField",
                    "name": "scores",
                    "plural": true,
                    "selections": [
                      (v224/*: any*/),
                      (v26/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VoteForPokerStorySuccess",
            "kind": "LinkedField",
            "name": "VoteForPokerStorySuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v250/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddReactjiToReactableSuccess",
            "kind": "LinkedField",
            "name": "AddReactjiToReactableSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "reactable",
                "plural": false,
                "selections": [
                  (v61/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Reactji",
                    "kind": "LinkedField",
                    "name": "reactjis",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v140/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddCommentSuccess",
            "kind": "LinkedField",
            "name": "AddCommentSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "comment",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v61/*: any*/),
                      (v257/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v255/*: any*/),
                          (v54/*: any*/),
                          (v256/*: any*/),
                          (v141/*: any*/),
                          (v93/*: any*/),
                          (v55/*: any*/),
                          (v258/*: any*/)
                        ],
                        "type": "Comment",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v55/*: any*/),
                          (v186/*: any*/),
                          (v251/*: any*/),
                          (v200/*: any*/),
                          (v201/*: any*/),
                          (v202/*: any*/),
                          (v203/*: any*/),
                          (v134/*: any*/),
                          (v19/*: any*/),
                          (v252/*: any*/),
                          (v126/*: any*/),
                          (v93/*: any*/),
                          (v204/*: any*/),
                          (v205/*: any*/),
                          (v64/*: any*/),
                          (v206/*: any*/),
                          (v258/*: any*/)
                        ],
                        "type": "Task",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v259/*: any*/),
                          (v6/*: any*/),
                          (v93/*: any*/),
                          (v35/*: any*/)
                        ],
                        "type": "Poll",
                        "abstractKey": null
                      }
                    ],
                    "type": "Threadable",
                    "abstractKey": "__isThreadable"
                  }
                ],
                "storageKey": null
              },
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CreatePollSuccess",
            "kind": "LinkedField",
            "name": "CreatePollSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Poll",
                "kind": "LinkedField",
                "name": "poll",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v3/*: any*/),
                  (v35/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v61/*: any*/),
                      (v257/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v255/*: any*/),
                          (v54/*: any*/),
                          (v256/*: any*/),
                          (v141/*: any*/),
                          (v93/*: any*/),
                          (v55/*: any*/),
                          (v33/*: any*/),
                          (v258/*: any*/)
                        ],
                        "type": "Comment",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v55/*: any*/),
                          (v186/*: any*/),
                          (v251/*: any*/),
                          (v200/*: any*/),
                          (v201/*: any*/),
                          (v202/*: any*/),
                          (v203/*: any*/),
                          (v134/*: any*/),
                          (v19/*: any*/),
                          (v252/*: any*/),
                          (v126/*: any*/),
                          (v93/*: any*/),
                          (v204/*: any*/),
                          (v205/*: any*/),
                          (v64/*: any*/),
                          (v33/*: any*/),
                          (v206/*: any*/),
                          (v258/*: any*/)
                        ],
                        "type": "Task",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v259/*: any*/),
                          (v6/*: any*/),
                          (v93/*: any*/)
                        ],
                        "type": "Poll",
                        "abstractKey": null
                      }
                    ],
                    "type": "Threadable",
                    "abstractKey": "__isThreadable"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CreateReflectionPayload",
            "kind": "LinkedField",
            "name": "CreateReflectionPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetroReflectionGroup",
                "kind": "LinkedField",
                "name": "reflectionGroup",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v36/*: any*/),
                  (v10/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v47/*: any*/),
                  (v148/*: any*/),
                  (v48/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/)
                ],
                "storageKey": null
              },
              (v260/*: any*/)
            ],
            "storageKey": null
          },
          (v56/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DragDiscussionTopicPayload",
            "kind": "LinkedField",
            "name": "DragDiscussionTopicPayload",
            "plural": false,
            "selections": [
              (v57/*: any*/),
              (v261/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EditCommentingSuccess",
            "kind": "LinkedField",
            "name": "EditCommentingSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Discussion",
                "kind": "LinkedField",
                "name": "discussion",
                "plural": false,
                "selections": [
                  (v62/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v63/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EndDraggingReflectionPayload",
            "kind": "LinkedField",
            "name": "EndDraggingReflectionPayload",
            "plural": false,
            "selections": [
              (v65/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RetroReflection",
                "kind": "LinkedField",
                "name": "reflection",
                "plural": false,
                "selections": (v262/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RetroReflectionGroup",
                "kind": "LinkedField",
                "name": "reflectionGroup",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v21/*: any*/),
                  (v36/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetroReflection",
                    "kind": "LinkedField",
                    "name": "reflections",
                    "plural": true,
                    "selections": (v262/*: any*/),
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v51/*: any*/)
                ],
                "storageKey": null
              },
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v19/*: any*/),
              (v70/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EndRetrospectiveSuccess",
            "kind": "LinkedField",
            "name": "EndRetrospectiveSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v72/*: any*/),
                  (v3/*: any*/),
                  (v264/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EndTeamPromptSuccess",
            "kind": "LinkedField",
            "name": "EndTeamPromptSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamPromptMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v264/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FlagReadyToAdvanceSuccess",
            "kind": "LinkedField",
            "name": "FlagReadyToAdvanceSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v61/*: any*/),
                  (v73/*: any*/),
                  (v74/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PromoteNewMeetingFacilitatorPayload",
            "kind": "LinkedField",
            "name": "PromoteNewMeetingFacilitatorPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v61/*: any*/),
                  (v75/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "facilitator",
                    "plural": false,
                    "selections": [
                      (v64/*: any*/),
                      (v169/*: any*/),
                      (v19/*: any*/),
                      (v60/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "oldFacilitator",
                "plural": false,
                "selections": [
                  (v76/*: any*/),
                  (v60/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "facilitatorStage",
                "plural": false,
                "selections": [
                  (v61/*: any*/),
                  (v74/*: any*/),
                  (v73/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveReflectionPayload",
            "kind": "LinkedField",
            "name": "RemoveReflectionPayload",
            "plural": false,
            "selections": [
              (v261/*: any*/),
              (v77/*: any*/),
              (v260/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ResetRetroMeetingToGroupStagePayload",
            "kind": "LinkedField",
            "name": "ResetRetroMeetingToGroupStagePayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v61/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v61/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "stages",
                        "plural": true,
                        "selections": [
                          (v61/*: any*/),
                          (v3/*: any*/),
                          (v78/*: any*/),
                          (v79/*: any*/),
                          (v52/*: any*/),
                          (v136/*: any*/),
                          (v74/*: any*/),
                          (v73/*: any*/),
                          (v111/*: any*/),
                          (v153/*: any*/),
                          (v85/*: any*/),
                          (v155/*: any*/),
                          (v84/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v111/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v129/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "meetingMembers",
                    "plural": true,
                    "selections": [
                      (v61/*: any*/),
                      (v3/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v76/*: any*/),
                          (v131/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v115/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "facilitator",
                    "plural": false,
                    "selections": [
                      (v64/*: any*/),
                      (v169/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v135/*: any*/),
                  (v110/*: any*/),
                  (v75/*: any*/),
                  (v81/*: any*/),
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "localStage",
                        "plural": false,
                        "selections": [
                          (v61/*: any*/),
                          (v136/*: any*/),
                          (v3/*: any*/),
                          (v78/*: any*/),
                          (v74/*: any*/),
                          (v73/*: any*/),
                          (v111/*: any*/),
                          (v153/*: any*/),
                          (v85/*: any*/),
                          (v155/*: any*/),
                          (v84/*: any*/),
                          (v211/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "localPhase",
                        "plural": false,
                        "selections": [
                          (v61/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              (v61/*: any*/),
                              (v136/*: any*/),
                              (v3/*: any*/),
                              (v78/*: any*/),
                              (v74/*: any*/),
                              (v73/*: any*/),
                              (v111/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v111/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v178/*: any*/)
                    ]
                  },
                  (v180/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RevealTeamHealthVotesSuccess",
            "kind": "LinkedField",
            "name": "RevealTeamHealthVotesSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamHealthStage",
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v88/*: any*/),
                  (v160/*: any*/),
                  (v137/*: any*/),
                  (v87/*: any*/),
                  (v89/*: any*/),
                  (v161/*: any*/),
                  (v162/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SetPhaseFocusPayload",
            "kind": "LinkedField",
            "name": "SetPhaseFocusPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReflectPhase",
                "kind": "LinkedField",
                "name": "reflectPhase",
                "plural": false,
                "selections": [
                  (v83/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SetStageTimerPayload",
            "kind": "LinkedField",
            "name": "SetStageTimerPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v61/*: any*/),
                  (v84/*: any*/),
                  (v85/*: any*/),
                  (v86/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SetTeamHealthVoteSuccess",
            "kind": "LinkedField",
            "name": "SetTeamHealthVoteSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamHealthStage",
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v87/*: any*/),
                  (v88/*: any*/),
                  (v89/*: any*/),
                  (v160/*: any*/),
                  (v137/*: any*/),
                  (v161/*: any*/),
                  (v162/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v90/*: any*/),
          (v92/*: any*/),
          (v94/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateNewCheckInQuestionPayload",
            "kind": "LinkedField",
            "name": "UpdateNewCheckInQuestionPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v61/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v61/*: any*/),
                      (v96/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v103/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdatePokerScopeSuccess",
            "kind": "LinkedField",
            "name": "UpdatePokerScopeSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "newStages",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v16/*: any*/),
                  (v78/*: any*/),
                  (v79/*: any*/),
                  (v104/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "task",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "integration",
                        "plural": false,
                        "selections": [
                          (v61/*: any*/),
                          (v3/*: any*/),
                          (v242/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v189/*: any*/),
                              (v188/*: any*/),
                              (v187/*: any*/),
                              (v217/*: any*/),
                              (v215/*: any*/),
                              (v216/*: any*/)
                            ],
                            "type": "JiraIssue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v189/*: any*/),
                              (v188/*: any*/),
                              (v187/*: any*/),
                              (v217/*: any*/),
                              (v218/*: any*/),
                              (v219/*: any*/),
                              (v220/*: any*/)
                            ],
                            "type": "JiraServerIssue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/),
                              (v192/*: any*/),
                              (v191/*: any*/),
                              (v221/*: any*/),
                              (v194/*: any*/)
                            ],
                            "type": "_xGitHubIssue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/),
                              (v197/*: any*/),
                              (v196/*: any*/),
                              (v198/*: any*/),
                              (v222/*: any*/)
                            ],
                            "type": "_xGitLabIssue",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v8/*: any*/),
                      (v55/*: any*/),
                      (v64/*: any*/),
                      (v223/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  (v226/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EstimateUserScore",
                    "kind": "LinkedField",
                    "name": "scores",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      (v26/*: any*/),
                      (v3/*: any*/),
                      (v224/*: any*/),
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  (v108/*: any*/),
                  (v64/*: any*/),
                  (v227/*: any*/),
                  (v31/*: any*/),
                  (v52/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PokerMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v135/*: any*/),
                  (v110/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v61/*: any*/),
                      (v111/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "stages",
                        "plural": true,
                        "selections": [
                          (v61/*: any*/),
                          (v3/*: any*/),
                          (v78/*: any*/),
                          (v79/*: any*/),
                          (v52/*: any*/),
                          (v213/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v228/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v75/*: any*/),
                  (v64/*: any*/),
                  (v235/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PokerMeetingMember",
                    "kind": "LinkedField",
                    "name": "meetingMembers",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v236/*: any*/),
                  (v237/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v238/*: any*/),
                      (v115/*: any*/),
                      (v171/*: any*/),
                      (v105/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "team",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v105/*: any*/),
                          (v172/*: any*/),
                          (v173/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "meetingMembers",
                        "plural": true,
                        "selections": [
                          (v61/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v76/*: any*/),
                              (v130/*: any*/),
                              (v131/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          (v152/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v240/*: any*/),
                      (v175/*: any*/),
                      (v210/*: any*/),
                      (v241/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RetroReflectionGroup",
                            "kind": "LinkedField",
                            "name": "reflectionGroups",
                            "plural": true,
                            "selections": (v58/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "RetrospectiveMeeting",
                        "abstractKey": null
                      },
                      (v180/*: any*/)
                    ],
                    "type": "NewMeeting",
                    "abstractKey": "__isNewMeeting"
                  },
                  (v244/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateReflectionContentPayload",
            "kind": "LinkedField",
            "name": "UpdateReflectionContentPayload",
            "plural": false,
            "selections": [
              (v261/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RetroReflection",
                "kind": "LinkedField",
                "name": "reflection",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v55/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetroReflectionGroup",
                    "kind": "LinkedField",
                    "name": "retroReflectionGroup",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateReflectionGroupTitlePayload",
            "kind": "LinkedField",
            "name": "UpdateReflectionGroupTitlePayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetroReflectionGroup",
                "kind": "LinkedField",
                "name": "reflectionGroup",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v48/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateRetroMaxVotesSuccess",
            "kind": "LinkedField",
            "name": "UpdateRetroMaxVotesSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v122/*: any*/),
                  (v123/*: any*/),
                  (v80/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetrospectiveMeetingMember",
                    "kind": "LinkedField",
                    "name": "viewerMeetingMember",
                    "plural": false,
                    "selections": (v265/*: any*/),
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VoteForReflectionGroupPayload",
            "kind": "LinkedField",
            "name": "VoteForReflectionGroupPayload",
            "plural": false,
            "selections": [
              (v125/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": (v265/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeetingMember",
                "kind": "LinkedField",
                "name": "meetingMember",
                "plural": false,
                "selections": (v265/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RetroReflectionGroup",
                "kind": "LinkedField",
                "name": "reflectionGroup",
                "plural": false,
                "selections": [
                  (v47/*: any*/),
                  (v51/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpsertTeamPromptResponseSuccess",
            "kind": "LinkedField",
            "name": "UpsertTeamPromptResponseSuccess",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamPromptResponse",
                "kind": "LinkedField",
                "name": "teamPromptResponse",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v19/*: any*/),
                  (v55/*: any*/),
                  (v8/*: any*/),
                  (v93/*: any*/),
                  (v126/*: any*/),
                  (v141/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "s_7YxRrYuPp_yc38fCPNbzpg",
    "metadata": {},
    "name": "MeetingSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node ).hash = "1f170e3b5d8928b3edbb1a07b94aa1dc";

export default node;
